import React, { useState } from 'react';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { registerClient } from '../../services/api';

const Register: React.FC = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await registerClient({ name, email, phone, password });
      navigate('/login');
    } catch (error) {
      setError('Registration failed');
    }
  };

  return (
    <Container maxWidth="sm">
      <Paper 
        elevation={3} 
        sx={{ 
          p: 4, 
          mt: 8,
          background: (theme) => theme.palette.background.paper,
          backdropFilter: 'blur(20px)',
        }}
      >
        <Typography 
          variant="h4" 
          align="center" 
          gutterBottom
          sx={{ color: 'text.primary', fontWeight: 500 }}
        >
          Register
        </Typography>
        {error && (
          <Typography 
            color="error" 
            align="center" 
            gutterBottom
            sx={{ 
              color: 'primary.main',
              backgroundColor: 'primary.light',
              p: 1,
              borderRadius: 1
            }}
          >
            {error}
          </Typography>
        )}
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            margin="normal"
            required
            sx={{
              '& label': { color: 'text.secondary' },
              '& label.Mui-focused': { color: 'primary.main' },
            }}
          />
          <TextField
            fullWidth
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            margin="normal"
            required
            sx={{
              '& label': { color: 'text.secondary' },
              '& label.Mui-focused': { color: 'primary.main' },
            }}
          />
          <TextField
            fullWidth
            label="Phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            margin="normal"
            required
            sx={{
              '& label': { color: 'text.secondary' },
              '& label.Mui-focused': { color: 'primary.main' },
            }}
          />
          <TextField
            fullWidth
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            margin="normal"
            required
            sx={{
              '& label': { color: 'text.secondary' },
              '& label.Mui-focused': { color: 'primary.main' },
            }}
          />
          <Box sx={{ mt: 2 }}>
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                backgroundColor: 'primary.main',
                color: 'text.light',
                '&:hover': {
                  backgroundColor: 'primary.dark',
                },
              }}
            >
              Register
            </Button>
          </Box>
        </form>
      </Paper>
    </Container>
  );
};

export default Register; 